var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-rate"},[_c('van-rate',{attrs:{"count":_vm.count,"size":_vm.size,"readonly":_vm.readonly,"allow-half":_vm.allowHalf,"icon":_vm.icon,"void-icon":_vm.voidIcon,"gutter":_vm.gutter},on:{"change":_vm.handleChange},model:{value:(_vm.score),callback:function ($$v) {_vm.score=$$v},expression:"score"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }